module.exports = __webpack_public_path__ + "static/img/nose_06.f6aa104.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/noses/thumbnail/nose_06.png
// module id = /Pzt
// module chunks = 0